import React from 'react';

import { Box, Icon, Link, VStack } from '@/components';
import { useTranslation } from '@/hooks';
import SellersIcon from '@/svgs/dashboard/drawer/sellers-icon.svg';
import TopAgentsIcon from '@/svgs/dashboard/drawer/top-agents.svg';
import Top15Icon from '@/svgs/dashboard/drawer/top15.svg';

type Props = {
  isMeetUp?: boolean;
};

const BoardLinks: React.FC<Props> = ({ isMeetUp = false }) => {
  const { t } = useTranslation('components.staticsData');

  const boards = [
    {
      link: `${process.env.NEXT_PUBLIC_EVENT_BOARDS}/top15`,
      title: t('top15'),
      color: '#41bfe9',
      icon: Top15Icon,
      meetUpOnly: false,
    },
    {
      link: `${process.env.NEXT_PUBLIC_EVENT_BOARDS}/sellers-event?utm_source=liateam&utm_medium=menu&utm_campaign=mordad03bs`,
      title: t('bestSellers'),
      color: '#FFCCDC',
      icon: SellersIcon,
      meetUpOnly: false,
    },
    {
      link: `${process.env.NEXT_PUBLIC_EVENT_BOARDS}/top-agents`,
      title: t('topAgents'),
      color: '#CBC9FE',
      icon: TopAgentsIcon,
      meetUpOnly: false,
    },
  ];
  return (
    <VStack
      mt={{ base: 4, md: 8 }}
      gap={4}
      w="full"
      px={5}
      mb={{ base: 4, md: 0 }}
    >
      {boards.map((item) => (
        <Link
          position="relative"
          key={item.title}
          maxW={96}
          w="full"
          href={item.link}
          borderRadius="curved"
          target="_blank"
          prefetch={false}
          bg={item.color}
          color="text"
          fontSize="sm"
          textAlign="center"
          py={3}
          fontWeight="medium"
          h="44px"
          display={{
            base: 'flex',
            md: item.meetUpOnly
              ? isMeetUp
                ? 'flex'
                : 'none'
              : isMeetUp
                ? 'none'
                : 'flex',
          }}
          justifyContent="center"
          alignItems="center"
          gap={2}
        >
          {item.icon && <Icon as={item.icon} h={6} w={6} />}
          <Box as="span">
            {item.title}{' '}
            <Box
              as="span"
              display={{
                base: item.meetUpOnly ? ' inline' : 'none',
                md: 'none',
              }}
            >
              - {t('meetUp3')}
            </Box>
          </Box>
        </Link>
      ))}
    </VStack>
  );
};

export default BoardLinks;
